import ModalPaymentSecurity from './ModalPaymentSecurity';
export default ModalPaymentSecurity;
